import { render, staticRenderFns } from "./FooterBlocked.vue?vue&type=template&id=08186a5f&"
import script from "./FooterBlocked.vue?vue&type=script&lang=js&"
export * from "./FooterBlocked.vue?vue&type=script&lang=js&"
import style0 from "./FooterBlocked.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports